module.exports = __webpack_public_path__ + "img/hread.2362683b.png";